<template>
  <div class="my-2">
    <template
      v-for="(button, i) in buttonsList"
      :key="`${i}-${generateRandomCustomKey}`"
    >
      <v-tooltip
        v-if="
          'show' in button
            ? typeof button.show === 'function'
              ? button.show()
              : button.show
            : true
        "
        location="top"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :variant="!isIcon ? 'flat' : 'outlined'"
            :color="color || 'primary'"
            :size="isIcon ? 'small' : 'x-small'"
            class="action-button"
            :disabled="
              disabled || ('disabled' in button ? button.disabled?.(item) as unknown as boolean : false)
            "
            :loading="button.loading ? button.loading(item) as unknown as boolean : false"
            v-blur
            :icon="true"
            @click="
              () =>
                'action' in button && button.action ? button.action(item) : null
            "
          >
            <v-icon size="large">{{
              typeof button.icon === 'function'
                ? `mdi-${button.icon(item)}`
                : `mdi-${button.icon}`
            }}</v-icon>
          </v-btn>
        </template>
        <span>
          {{
            typeof button.toolTip === 'function'
              ? button.toolTip(item)
              : button.toolTip
          }}
        </span>
      </v-tooltip>
    </template>
  </div>
</template>

<script setup lang="ts">
import { IActionButton } from '@/Core.UI.Domain/Components/types/actionButtons';
import { generateRandomCustomKey } from '@/Core.Patterns/Factory';

defineProps<{
  buttonsList: IActionButton[];
  disabled?: boolean;
  color?: string;
  item?: object;
  isIcon?: boolean;
}>();
</script>
<style lang="scss" scoped>
.action-button {
  margin-left: 12px;
  margin-right: 5px;
}
</style>
